
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { FormTextarea } from "@/components/ui/form-textarea";

interface QuestionFormProps {
  question: string;
  setQuestion: (question: string) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isLoading: boolean;
}

const QuestionForm: React.FC<QuestionFormProps> = ({
  question,
  setQuestion,
  handleSubmit,
  isLoading
}) => {
  return (
    <Card id="moral-dilemmas-form" className="mb-8 border-heaven-gold/20 shadow-md">
      <CardHeader>
        <CardTitle className="text-xl font-semibold text-[#403E43]">
          Get Biblical Guidance for Moral Dilemmas
        </CardTitle>
        <CardDescription>
          Ask about real-life ethical situations and receive Scripture-based guidance
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <FormTextarea
            label="Your Question"
            id="question-textarea"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Describe your situation or ask about a specific moral or ethical dilemma..."
            className="min-h-[100px] text-base"
          />
          
          <Button
            type="submit"
            className="w-full bg-heaven-gold hover:bg-heaven-dark-gold text-white py-6 rounded-md"
            disabled={isLoading || !question.trim()}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing...
              </>
            ) : (
              "Get Biblical Guidance"
            )}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default QuestionForm;
